import React, { useEffect, useState } from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { SelectInput } from '@uhg-abyss/web/ui/SelectInput';
import { useForm } from '@uhg-abyss/web/hooks/useForm';
import practiceTypes from './practiceTypes.json';

const TextStyle = styled('div', {
  margin: '1px 565px 1px 30px',
});

export const PracticeType = () => {
  const form = useForm();
  const [practiceTypeList, setPracticeTypeList] = useState([]);
  const practiceSel = form.getValues('practiceInformation.practiceTypeValue');
  const practiceTypeSel = form.getValues(
    'practiceInformation.practiceTypeSelection'
  );

  useEffect(() => {
    setPracticeTypeList(practiceTypes);

    if (practiceSel && practiceTypeSel && practiceSel === practiceTypeSel) {
      form.setValue('practiceInformation.practiceTypeSelection', practiceSel);
    }
  }, []);
  return (
    <React.Fragment>
      <TextStyle>
        <SelectInput
          id="practiceType"
          label="Practice type"
          model="practiceInformation.practiceTypeSelection"
          value={practiceTypeSel}
          isSearchable
          placeholder="Select One"
          onChange={(value) => {
            form.setValue('practiceInformation.practiceTypeSelection', value);
          }}
          options={practiceTypeList}
          validators={{ required: 'Please select one.' }}
        />
      </TextStyle>
    </React.Fragment>
  );
};

PracticeType.propTypes = {};

PracticeType.defaultProps = {};
